import z from 'zod';

/**
 * How urgently the sales team should chase a Lead.
 *
 * - `hot`  — high-intent, follow-up today.
 * - `warm` — interested, follow-up this week.
 * - `cold` — low signal, follow-up when capacity allows.
 */
export const leadPrioritySchema = z.enum(['hot', 'warm', 'cold']);
export type LeadPriority = z.infer<typeof leadPrioritySchema>;
